import classNames from 'classnames';
import Radio from '@alltrails/denali/components/Radio';
import styles from './DescriptiveRadioButton.module.scss';

export type DescriptiveRadioButtonProps = {
  autoFocus?: boolean;
  name?: string;
  onChange: (value: string) => void;
  selected: boolean;
  subtext: string;
  title: string;
  value: string;
  borderBottom?: boolean;
  icon?: React.ReactNode;
};

type LabelProps = {
  title: string;
  subtext: string;
};

const Label = ({ title, subtext }: LabelProps) => (
  <div className={styles.labelContainer}>
    <div className={styles.title}>{title}</div>
    <div className={styles.subtext}>{subtext}</div>
  </div>
);

const DescriptiveRadioButton = ({
  autoFocus,
  name,
  onChange,
  selected,
  title,
  subtext,
  value,
  borderBottom = false,
  icon
}: DescriptiveRadioButtonProps) => (
  <div className={classNames(styles.container, { [styles.borderBottom]: borderBottom })}>
    <Radio
      autoFocus={autoFocus}
      labelElement={<Label title={title} subtext={subtext} />}
      name={name}
      onChange={onChange}
      selected={selected}
      size="md"
      value={value}
      verticalAlignment="center"
    />
    {icon && <div className={styles.iconContainer}> {icon} </div>}
  </div>
);

export default DescriptiveRadioButton;
